<template>
  <Modal>
    <Modal.Title>Add a profile photo</Modal.Title>
    <Modal.Body>
      <div
        class="flex h-[150px] w-full items-center justify-center rounded-[8px] border text-[14px] text-gray-800"
        :class="
          dragging ? 'border-green-900 bg-green-900/5' : 'border-gray-800/20'
        "
        @dragover.prevent="dragging = true"
        @dragleave.prevent="dragging = false"
        @drop.prevent="handleDrop"
      >
        <div v-if="!dragging" class="text-center">
          <span class="mr-1">Drag and drop or</span>
          <button
            type="button"
            class="font-medium text-link cursor-pointer"
            @click="handleUploadClick"
          >
            upload from computer
          </button>
        </div>
        <div v-else class="pointer-events-none">Drop file to upload</div>
      </div>
    </Modal.Body>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Modal } from '@dacr/library'
import { openModal, Modals } from '@/shared/dialogs/modals'

const dragging = ref(false)

const handleFile = (file: File) => {
  openModal(Modals.ConfirmProfilePicture, { props: { file } })
}

const handleDrop = (event: DragEvent) => {
  dragging.value = false

  const file = event.dataTransfer?.files[0]

  if (file && file.type.startsWith('image')) handleFile(file)
}

const handleUploadClick = () => {
  const input = document.createElement('input')
  input.type = 'file'
  input.accept = 'image/*'
  input.click()

  input.onchange = (event: Event) => {
    const file = (event.target as HTMLInputElement).files?.[0]
    if (file) handleFile(file)
  }
}
</script>
